import StudentCountByTeacherReport from "@/pages/reports/print/student-count-by-teacher";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/reports/detailed-view/student-count-by-teacher/$teacherId",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <StudentCountByTeacherReport />;
}
